import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/legal/new")({
  component: lazyRouteComponent(() => import("./+NewLegalTermsPage")),
  beforeLoad: () => ({ breadcrumb: "New Document" }),
  head: () => ({ meta: seo({ title: "New Legal Terms" }) }),
});
